<script setup lang="ts">
const props = defineProps<{
   name: string;
   description: string;
   imageSrc?: string;
}>();
</script>

<template>
   <article class="block-select">
      <div class="block-select__description">
         <h2>{{ props.name }}</h2>
         <p>{{ props.description }}</p>
      </div>
      <div class="block-select__image">
         <img v-if="props.imageSrc" :src="imageSrc" class="block-image" />
      </div>
   </article>
</template>

<style lang="scss" scoped>
.block-select {
   display: flex;
   margin: 5px;
   border: 2px solid var(--nxt-grey);
   border-radius: 5px;
   overflow: hidden;
   cursor: pointer;
   min-height: 70px;

   &__description,
   &__image {
      flex: 1 1 0;
      display: flex;
      flex-direction: column;
   }

   &__description {
      padding: 10px;

      h2 {
         margin: 0;
         font-weight: 700;
         font-size: 12px;
      }

      p {
         margin: 0;
      }
   }

   &__image {
      background-color: #fff;
      justify-content: center;

      .block-image {
         max-width: 100%;
         object-fit: contain;
      }
   }
}
</style>
